//订单管理请求
import request from '../../utils/request'
import { UrlSearch } from "../../utils/UrlSearch";
const shopTitle = UrlSearch().shop;
let shopName ;
if(shopTitle){
  let index = shopTitle.indexOf('.');
  if(index>0){
      shopName = shopTitle.substring(0,index);
  }else{
      shopName = shopTitle;
  }

}

export function getproduct(param) {
    param.shopName = shopName;
  return request({
    url: `product-list`,
    method: 'post',
    params: param
  })
}


export function productaddcff(param) {
    param.shopName = shopName;
  return request({
    url: `product-add-to-cff`,
    method: 'post',
    params: param
  })
}


export function receivingitem(param){
    param.shopName = shopName;
  return request({
    url: `receiving-item`,
    method: 'post',
    params: param
  })
}

export function getordershipbyproduct(param){
    param.shopName = shopName;
  return request({
    url: `get-order-ship-by-product`,
    method: 'post',
    params: param
  })
}

export function downproduct(){
  let param={}
  param.shopName = shopName;
  return request({
    url: `down-product`,
    method: 'post',
    params: param
  })
}









// WEBPACK FOOTER //
// ./src/components/views/api/product.js